'use client';
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '@wwe-portal/web/utils/config';
import { reloadOTBanner } from '../../external/ot-banner-initiator';
import { SOCIAL_LINKS_MENU } from '../../../utils/constants/pages';
import { FooterContent } from '@wwe-portal/ui/layout/app/left-sidebar/footer-content';
import { ClickableDiv } from '@wwe-portal/ui/components/button';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
import { sendStoreClickEvent } from '@wwe-portal/web/libs/analytics/side-bar';

export const FooterOverhaul = () => {
  return (
    <>
      <div className="mx-auto mt-10 flex max-w-[300px] flex-col items-center justify-center gap-6">
        {/* Forum button hidden
        <ForumButton
          className="w-full"
          icon={
            <Image
              alt="logo"
              className="h-[29px]"
              draggable="false"
              width={32}
              height={29}
              src="/assets/images/common/forum-logo.webp"
            />
          }
          onClick={() => sendForumBtnClickEvent()}
        />
        */}
        <div className="flex flex-row items-center gap-2">
          <a
            href={GOOGLE_PLAY_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => sendStoreClickEvent('Dashboard', 'android')}
          >
            <img
              src="/assets/images/common/google-play.svg"
              width={128}
              height={40}
              alt="google play"
              className="h-10"
            />
          </a>
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => sendStoreClickEvent('Dashboard', 'ios')}
          >
            <img
              src="/assets/images/common/app-store.svg"
              width={128}
              height={40}
              alt="apple play"
              className="h-10"
            />
          </a>
        </div>
      </div>
      <div className="mt-6 flex justify-center gap-5">
        {SOCIAL_LINKS_MENU.map((item) => (
          <a
            key={item.key}
            href={item.url}
            rel="noopener noreferrer"
            target="_blank"
          >
            <IcoMoonIcon
              className="text-text300 hover:text-text700 max-h-[26px] max-w-[26px] cursor-pointer"
              iconName={item.icon}
            />
          </a>
        ))}
      </div>
      <div className="text-text300 mt-10 flex flex-col items-center justify-center gap-4">
        <a
          className="text-text300 hover:text-green700 hover:no-underline"
          data-id="left_sidebar_terms_link"
          href="https://scopely.com/tos/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Terms of Service
        </a>
        <a
          className="text-text300 hover:text-green700 hover:no-underline"
          data-id="left_sidebar_privacy_link"
          href="https://scopely.com/privacy/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Privacy Policy
        </a>
        <ClickableDiv
          id="ot-sdk-link"
          className="hover:text-green700 text-text300 cursor-pointer"
          onClick={reloadOTBanner}
        >
          Cookies
        </ClickableDiv>
      </div>

      <FooterContent className="text-text300 mx-auto w-full max-w-[300px] items-center justify-center text-center" />
    </>
  );
};
